export default class LocalStorageUtils {

	protected static prefix: string;

	protected static setPrefix(prefix: string): void {
		this.prefix = prefix;
	}

	protected static getPrefix(): string {
		return this.prefix;
	}

	protected static setItem(key: string, value: {}, needPrefix: boolean): void {
		const storageKey = this.getKey(key, needPrefix);
		localStorage.setItem(storageKey, JSON.stringify(value));
	}

	protected static getItem<T>(key: string, needPrefix: boolean): T | null {
		const storageKey = this.getKey(key, needPrefix);
		const rawItem = localStorage.getItem(storageKey);

		if (rawItem === null) {
			return null;
		}

		try {
			return JSON.parse(rawItem);
		} catch (e) {
			return null;
		}
	}

	protected static removeItem(key: string, needPrefix: boolean): void {
		const storageKey = this.getKey(key, needPrefix);
		localStorage.removeItem(storageKey);
	}

	protected static getKey(key: string, needPrefix: boolean): string {
		return needPrefix ? `${this.prefix}-${key}` : key;
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/localStorage/util.ts